import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import Button from 'components/shared/Button';
import {
  adminPortalProblemReportQueryKeys,
  indexAdminPortalProblemReports,
  UNRECOGNIZED_PORTAL,
} from 'services/api/admin/portalProblemReports';

// Portal Systems' way to the reports no portal row can hold: those sent from a page no portal
// recognized, often the portal nobody has set up yet. The count is the open ones, like a row's.
export default function UnrecognizedReportsLink() {
  const navigate = useNavigate();
  const { data } = useQuery({
    queryKey: [...adminPortalProblemReportQueryKeys.index(UNRECOGNIZED_PORTAL.systemName), 'openCount'],
    queryFn: ({ signal }) =>
      indexAdminPortalProblemReports(
        { sourceSystem: UNRECOGNIZED_PORTAL.systemName, status: 'open', pageSize: 1 },
        signal
      ),
  });
  const open = data?.meta.totalRecords ?? 0;

  return (
    <Button
      variant='outline-primary'
      onClick={() => navigate(`/admin/portal-systems/${UNRECOGNIZED_PORTAL.id}/problem-reports`)}>
      Unrecognized pages · {open ? `${open} open` : 'none open'}
    </Button>
  );
}
